// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@6.8.6'

class SectionProductCarousel extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector(
      '[data-el="section-product-carousel.slides"]'
    )
    this.slideEls = this.querySelectorAll(
      '[data-el="section-product-carousel.slide"]'
    )
    this.progressEl = this.querySelector(
      '[data-el="section-product-carousel.progress"]'
    )
    this.arrowNextEls = this.querySelectorAll(
      '[data-el="section-product-carousel.controlnext"]'
    )
    this.arrowPrevEls = this.querySelectorAll(
      '[data-el="section-product-carousel.controlprevious"]'
    )

    this.productCardType = this.dataset.productCardType || 'single'

    // Configure carousel's slides per view and disabled state based on the product card type and number of slides
    this.slidesPerView = {
      mobile: this.productCardType === 'single' ? 1.2 : 1,
      tablet: this.productCardType === 'single' ? 2 : 1.5,
      smallDesktop: this.productCardType === 'single' ? 4 : 2,
      largeDesktop: this.productCardType === 'single' ? 4 : 2.5,
    }
    this.carouselDisabled = {
      mobile: this.slideEls.length <= this.slidesPerView.mobile,
      tablet: this.slideEls.length <= this.slidesPerView.tablet,
      smallDesktop: this.slideEls.length <= this.slidesPerView.smallDesktop,
      largeDesktop: this.slideEls.length <= this.slidesPerView.largeDesktop,
    }

    this.carousel = this.initialiseCarousel()
    this.toggleControlsVisibility() // Ensure the controls visibility is set correctly on load

    window.addEventListener('resize', this.toggleControlsVisibility.bind(this))

    if (this.slideEls.length >= 2) {
      this.carousel = this.initialiseCarousel()
      this.arrowNextEls.forEach(arrowNextEl => {
        arrowNextEl.addEventListener('click', this.changeCarousel.bind(this))
      })
      this.arrowPrevEls.forEach(arrowPrevEl => {
        arrowPrevEl.addEventListener('click', this.changeCarousel.bind(this))
      })
    }
  }

  toggleControlsVisibility () {
    const viewportWidth = window.innerWidth

    let shouldHideControls

    if (viewportWidth >= 1200) {
      shouldHideControls = this.carouselDisabled.largeDesktop
    } else if (viewportWidth >= 900) {
      shouldHideControls = this.carouselDisabled.smallDesktop
    } else if (viewportWidth >= 768) {
      shouldHideControls = this.carouselDisabled.tablet
    } else {
      shouldHideControls = this.carouselDisabled.mobile
    }

    if (shouldHideControls) {
      this.arrowNextEls.forEach(arrow => {
        arrow.style.display = 'none'
      })
      this.arrowPrevEls.forEach(arrow => {
        arrow.style.display = 'none'
      })
      if (this.progressEl) {
        this.progressEl.parentElement.style.display = 'none'
      }
    } else {
      this.arrowNextEls.forEach(arrow => {
        arrow.style.display = ''
      })
      this.arrowPrevEls.forEach(arrow => {
        arrow.style.display = ''
      })
      if (this.progressEl) {
        this.progressEl.parentElement.style.display = ''
      }
    }
  }

  initialiseCarousel () {
    return new KeenSlider(this.slidesEl, {
      duration: 1000,
      loop: false,
      mode: 'snap',
      rubberband: false,
      selector: this.slideEls,
      slidesPerView: this.slidesPerView.mobile,
      slides: {
        perView: this.slidesPerView.mobile,
        spacing: 4,
      },
      disabled: this.carouselDisabled.mobile,
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: this.slidesPerView.tablet,
            spacing: 4,
          },
          disabled: this.carouselDisabled.tablet,
        },
        '(min-width: 900px)': {
          slides: {
            perView: this.slidesPerView.smallDesktop,
            spacing: 8,
          },
          disabled: this.carouselDisabled.smallDesktop,
        },
        '(min-width: 1200px)': {
          slides: {
            perView: this.slidesPerView.largeDesktop,
            spacing: 12,
          },
          disabled: this.carouselDisabled.largeDesktop,
        },
      },
      detailsChanged: instance => {
        if (this.progressEl) {
          const progress = instance.track.details.progress
          let movementPercentage = `${progress * 100}%`

          if (progress >= 0.9) {
            movementPercentage = 'calc(100% - var(--bar-width))'
          }

          this.progressEl.style.setProperty(
            '--progress',
            `${movementPercentage}`
          )
        }
      },
      created: () => {
        this.slidesEl.setAttribute('data-initialised', true)
      },
      destroyed: () => {
        this.slidesEl.removeAttribute('data-initialised')
      },
    })
  }

  changeCarousel (e) {
    if (e.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

customElements.define('section-product-carousel', SectionProductCarousel)
